<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process col-md-3"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import LocationServices from '@/services/api/location.api'
import codeApi from '@/services/api/code.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Lugares de Servicios Disponibles para Vincular',
      routes: ['Informes', 'Lugares de Servicios Disponibles para Vincular'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          centers: [],
          disciplineTypes: [],
          municipalities: [],
          locations: [],
          locationTypes: [],
        },
        filters: {
          academicYear: null,
          error: null,
          provider: null,
          specialist: null,
          center: null,
          location: null,
          locationType: null,
          municipality: null,
          disciplineType: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          class: 'col-md-3',
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-3',
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
          clearable: true,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-md-3',
          onChanged: this.onChangedCenter,
          disabled: this.model.search.collections.centers.length <= 0,
          clearable: true,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
          onChanged: this.onChangedMunicipality,
          disabled: this.model.search.collections.municipalities.length <= 0,
          clearable: true,
        },
        {
          name: 'locationType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Lugar',
          placeholder: 'Seleccionar',
          validations: '',
          clearable: true,
          options: this.model.search.collections.locationTypes,
          value: this.model.search.filters.locationType,
          onChanged: this.onLocationTypeChanged,
          disabled: this.model.search.collections.locationTypes.length <= 0,
          class: 'col-md-3',
        },
        {
          name: 'location',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Lugar de Servicio',
          placeholder: 'Seleccionar',
          validations: '',
          clearable: true,
          options: this.model.search.collections.locations,
          value: this.model.search.filters.location,
          disabled: this.model.search.collections.locations.length <= 0,
          class: 'col-md-3',
        },
        {
          name: 'disciplineType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Disciplina:',
          placeholder: 'Seleccione',
          class: 'col-md-3',
          clearable: true,
          options: this.model.search.collections.disciplineTypes,
          value: this.model.search.filters.disciplineType,
          disabled: this.model.search.collections.disciplineTypes?.length <= 0,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async onChangeAcademicYear() {
      this.model.search.collections.providers = []
      this.model.search.collections.centers = []
      this.model.search.collections.municipalities = []
      this.model.search.collections.locations = []

      this.model.search.filters.locationType = null
      this.model.search.filters.location = null
      this.model.search.filters.provider = null
      this.model.search.filters.municipality = null
      this.model.search.filters.disciplineType = null
      this.model.search.filters.center = null

      await this.getProvider()
      await this.getCenters()
    },
    async onChangeProvider() {
      this.model.search.filters.locationType = null
      this.model.search.filters.location = null
      this.model.search.filters.municipality = null
      this.model.search.filters.disciplineType = null
      this.model.search.filters.center = null
      this.model.search.filters.specialist = null
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => (this.model.search.collections.centers = res.data))
    },
    getLocationTypes() {
      LocationServices.getLocationTypes().then(
        (res) => (this.model.search.collections.locationTypes = res.data)
      )
    },
    async onChangedCenter() {
      this.model.search.filters.locationType = null
      this.model.search.filters.location = null
      this.model.search.filters.municipality = null
      this.model.search.filters.disciplineType = null
      await this.getMunicipalities()
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      }).then(
        (res) => (this.model.search.collections.municipalities = res.data)
      )
    },

    async onLocationTypeChanged() {
      this.model.search.collections.locations = []
      this.model.search.filters.location = null
      this.tryLoadProviderLocations()
    },
    async tryLoadProviderLocations() {
      if (
        this.model.search.filters.academicYear &&
        this.model.search.filters.provider &&
        this.model.search.filters.locationType
      ) {
        await LocationServices.getProviderLocations(
          this.model.search.filters.academicYear?.id,
          this.model.search.filters.provider?.id,
          this.model.search.filters.locationType?.id
        ).then((res) => (this.model.search.collections.locations = res.data))
      }
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
      await this.getLocationTypes()
      await this.getDisciplineTypeServices()
    },
    async getDisciplineTypeServices() {
      await codeApi.getDisciplineTypeServices().then((res) => {
        this.model.search.collections.disciplineTypes = res.data
      })
    },
    async onHandlerSearch() {
      await this.process()
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)) {
        await ReportServices.getReport('availableServices', {
          AcademicYearId: this.model.search.filters.academicYear?.id,
          CompanyId: this.model.search.filters.provider?.id,
          MunicipalityId: this.model.search.filters.municipality?.id,
          DisciplineTypeId: this.model.search.filters.disciplineType?.id,
          CenterId: this.model.search.filters.center?.id,
          LocationId: this.model.search.filters.location?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
    async getProvider() {
      await providerApi
        .getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
            this.getSpecialist()
          }
        })
    },

    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined
    },
  },
}
</script>
